import db from '../../plugins/firebase'
import { collection, query, getDocs, addDoc, updateDoc, doc } from "firebase/firestore"

const getAllObras = async () => {
  const querySnap = await getDocs(query(collection(db, 'obras')));
  const obrasList = []
  querySnap.forEach((doc) => {
    obrasList.push({ id: doc.id, ...doc.data() })
  })
  return obrasList;
}

const deleteObra = async (payload) => {
  const colRef = await doc(db, 'obras', payload.id);
  await updateDoc(colRef, {
    ...payload,
    active: false
  });
}

const saveObra = async (payload) => {
  const colRef = collection(db, 'obras')
  await addDoc(colRef, payload)
}

const updateObra = async (payload) => {
  const colRef = await doc(db, 'obras', payload.id);
  await updateDoc(colRef, payload);
}

export { getAllObras, saveObra, updateObra, deleteObra }
